<template>
    <div class="py-md-4 shape_block">
      <div class="shape_main">
            <div class="shape_flex for_desktop">
                <div class="slide_box" :class="{ active: activeShape === 'round' }" @click="$emit('shapeSelected', 'round')">
                    <NuxtLink class="for_mobile">
                        <picture>
                        <source width="40" height="40" type="image/webp" srcset="~/assets/shapes/round.webp">
                        <img loading="lazy" width="40" height="40" type="image/jpeg" src="~/assets/shapes/round.jpg" alt="Round Cut Diamonds">
                        </picture>
                        <span>round</span>
                    </NuxtLink>
                    <div class="shape_area for_desktop">
                        <NuxtLink >
                            <picture>
                            <source width="50" height="50" type="image/webp" srcset="~/assets/shapes/round.webp">
                            <img loading="lazy" width="50" height="50" type="image/jpeg" src="~/assets/shapes/round.jpg" alt="Round Cut Diamonds">
                            </picture>
                            <span>round</span>
                        </NuxtLink>
                    </div>

                </div>
                <div class="slide_box" :class="{ active: activeShape === 'oval' }" @click="$emit('shapeSelected', 'oval')">
                    <NuxtLink class="for_mobile">
                        <picture>
                        <source width="40" height="40" type="image/webp" srcset="~/assets/shapes/oval.webp">
                        <img loading="lazy" width="40" height="40" type="image/jpeg" src="~/assets/shapes/oval.jpg" alt="Oval Cut Diamonds">
                        </picture>
                        <span>oval</span>
                    </NuxtLink>
                    <div class="shape_area for_desktop radious_eight">
                        <NuxtLink >
                            <picture>
                            <source width="50" height="50" type="image/webp" srcset="~/assets/shapes/oval.webp">
                            <img loading="lazy" width="50" height="50" type="image/jpeg" src="~/assets/shapes/oval.jpg" alt="Oval Cut Diamonds">
                            </picture>
                            <span>oval</span>
                        </NuxtLink>
                    </div>

                </div>
                <div class="slide_box" :class="{ active: activeShape === 'pear' }" @click="$emit('shapeSelected', 'pear')">
                    <NuxtLink  class="for_mobile">
                        <picture>
                        <source width="40" height="40" type="image/webp" srcset="~/assets/shapes/pear.webp">
                        <img loading="lazy" width="40" height="40" type="image/jpeg" src="~/assets/shapes/pear.jpg" alt="Pear Cut Diamonds">
                        </picture>
                        <span>pear</span>
                    </NuxtLink>
                    <div class="shape_area for_desktop radious_eight">
                        <NuxtLink >
                            <picture>
                            <source width="50" height="50" type="image/webp" srcset="~/assets/shapes/pear.webp">
                            <img loading="lazy" width="50" height="50" type="image/jpeg" src="~/assets/shapes/pear.jpg" alt="Pear Cut Diamonds">
                            </picture>
                            <span>pear</span>
                        </NuxtLink>
                    </div>

                </div>
                <div class="slide_box" :class="{ active: activeShape === 'cushion' }" @click="$emit('shapeSelected', 'cushion')">
                    <NuxtLink  class="for_mobile">
                        <picture>
                        <source width="40" height="40" type="image/webp" srcset="~/assets/shapes/cushion.webp">
                        <img loading="lazy" width="40" height="40" type="image/jpeg" src="~/assets/shapes/cushion.jpg" alt="Cushion Cut Diamonds">
                        </picture>
                        <span>cushion</span>
                    </NuxtLink>
                    <div class="shape_area for_desktop radious_eight">
                        <NuxtLink >
                            <picture>
                            <source width="50" height="50" type="image/webp" srcset="~/assets/shapes/cushion.webp">
                            <img loading="lazy" width="50" height="50" type="image/jpeg" src="~/assets/shapes/cushion.jpg" alt="Cushion Cut Diamonds">
                            </picture>
                            <span>cushion</span>
                        </NuxtLink>
                    </div>

                </div>
                <div class="slide_box" :class="{ active: activeShape === 'princess' }" @click="$emit('shapeSelected', 'princess')">
                    <NuxtLink  class="for_mobile">
                        <picture>
                        <source width="40" height="40" type="image/webp" srcset="~/assets/shapes/princess.webp">
                        <img loading="lazy" width="40" height="40" type="image/jpeg" src="~/assets/shapes/princess.jpg" alt="Princess Cut Diamonds">
                        </picture>
                        <span>princess</span>
                    </NuxtLink>
                    <div class="shape_area for_desktop">
                        <NuxtLink >
                            <picture>
                            <source width="50" height="50" type="image/webp" srcset="~/assets/shapes/princess.webp">
                            <img loading="lazy" width="50" height="50" type="image/jpeg" src="~/assets/shapes/princess.jpg" alt="Princess Cut Diamonds">
                            </picture>
                            <span>princess</span>
                        </NuxtLink>
                    </div>

                </div>
                <div class="slide_box" :class="{ active: activeShape === 'radiant' }" @click="$emit('shapeSelected', 'radiant')">
                    <NuxtLink  class="for_mobile">
                        <picture>
                        <source width="40" height="40" type="image/webp" srcset="~/assets/shapes/radiant.webp">
                        <img loading="lazy" width="40" height="40" type="image/jpeg" src="~/assets/shapes/radiant.jpg" alt="Radiant Cut Diamonds">
                        </picture>
                        <span>radiant</span>
                    </NuxtLink>
                    <div class="shape_area for_desktop">
                        <NuxtLink >
                            <picture>
                            <source width="50" height="50" type="image/webp" srcset="~/assets/shapes/radiant.webp">
                            <img loading="lazy" width="50" height="50" type="image/jpeg" src="~/assets/shapes/radiant.jpg" alt="Radiant Cut Diamonds">
                            </picture>
                            <span>radiant</span>
                        </NuxtLink>
                    </div>

                </div>
                <div class="slide_box" :class="{ active: activeShape === 'emerald' }" @click="$emit('shapeSelected', 'emerald')">
                    <NuxtLink  class="for_mobile">
                        <picture>
                        <source width="40" height="40" type="image/webp" srcset="~/assets/shapes/emerald.webp">
                        <img loading="lazy" width="40" height="40" type="image/jpeg" src="~/assets/shapes/emerald.jpg" alt="Emerald Cut Diamonds">
                        </picture>
                        <span>emerald</span>
                    </NuxtLink>
                    <div class="shape_area for_desktop radious_eight">
                        <NuxtLink >
                            <picture>
                            <source width="50" height="50" type="image/webp" srcset="~/assets/shapes/emerald.webp">
                            <img loading="lazy" width="50" height="50" type="image/jpeg" src="~/assets/shapes/emerald.jpg" alt="Emerald Cut Diamonds">
                            </picture>
                            <span>emerald</span>
                        </NuxtLink>
                    </div>

                </div>
                <div class="slide_box" :class="{ active: activeShape === 'heart' }" @click="$emit('shapeSelected', 'heart')">
                    <NuxtLink  class="for_mobile">
                        <picture>
                        <source width="40" height="40" type="image/webp" srcset="~/assets/shapes/heart.webp">
                        <img loading="lazy" width="40" height="40" type="image/jpeg" src="~/assets/shapes/heart.jpg" alt="Heart Cut Diamonds">
                        </picture>
                        <span>heart</span>
                    </NuxtLink>
                    <div class="shape_area for_desktop">
                        <NuxtLink >
                            <picture>
                            <source width="50" height="50" type="image/webp" srcset="~/assets/shapes/heart.webp">
                            <img loading="lazy" width="50" height="50" type="image/jpeg" src="~/assets/shapes/heart.jpg" alt="Heart Cut Diamonds">
                            </picture>
                            <span>heart</span>
                        </NuxtLink>
                    </div>

                </div>
                <div class="slide_box" :class="{ active: activeShape === 'asscher' }" @click="$emit('shapeSelected', 'asscher')">
                    <NuxtLink class="for_mobile">
                        <picture>
                        <source width="40" height="40" type="image/webp" srcset="~/assets/shapes/asscher.webp">
                        <img loading="lazy" width="40" height="40" type="image/jpeg" src="~/assets/shapes/asscher.jpg" alt="Asscher Cut Diamonds">
                        </picture>
                        <span>asscher</span>
                    </NuxtLink>
                    <div class="shape_area for_desktop">
                        <NuxtLink >
                            <picture>
                            <source width="50" height="50" type="image/webp" srcset="~/assets/shapes/asscher.webp">
                            <img loading="lazy" width="50" height="50" type="image/jpeg" src="~/assets/shapes/asscher.jpg" alt="Asscher Cut Diamonds">
                            </picture>
                            <span>asscher</span>
                        </NuxtLink>
                    </div>

                </div> 
                <div class="slide_box" :class="{ active: activeShape === 'marquise' }" @click="$emit('shapeSelected', 'marquise')">
                    <NuxtLink class="for_mobile">
                        <picture>
                        <source width="40" height="40" type="image/webp" srcset="~/assets/shapes/marquise.webp">
                        <img loading="lazy" width="40" height="40" type="image/jpeg" src="~/assets/shapes/marquise.jpg" alt="Marquise Cut Diamonds">
                        </picture>
                        <span>marquise</span>
                    </NuxtLink>
                    <div class="shape_area for_desktop">
                        <NuxtLink>
                            <picture>
                            <source width="50" height="50" type="image/webp" srcset="~/assets/shapes/marquise.webp">
                            <img loading="lazy" width="50" height="50" type="image/jpeg" src="~/assets/shapes/marquise.jpg" alt="Marquise Cut Diamonds">
                            </picture>
                            <span>marquise</span>
                        </NuxtLink>
                    </div>
                </div>
            </div>

            <div class="for_mobile">
                <swiper 
              v-bind="swiperOptions"
          >
              <swiper-slide >
                  <div class="slide_box" :class="{ active: activeShape === 'round' }" @click="$emit('shapeSelected', 'round')">
                      <NuxtLink >
                          <picture>
                              <source width="40" height="40" type="image/webp" srcset="~/assets/shapes/round.webp">
                              <img width="40" height="40" type="image/jpeg" src="~/assets/shapes/round.jpg"
                                  alt="Round Cut Diamonds">
                          </picture>
                          <span>round</span>
                      </NuxtLink>
                  </div>
              </swiper-slide>
              <swiper-slide>
                  <div class="slide_box" :class="{ active: activeShape === 'oval' }" @click="$emit('shapeSelected', 'oval')">
                      <NuxtLink >
                          <picture>
                              <source width="40" height="40" type="image/webp" srcset="~/assets/shapes/oval.webp">
                              <img width="40" height="40" type="image/jpeg" src="~/assets/shapes/oval.jpg"
                                  alt="Oval Cut Diamonds">
                          </picture>
                          <span>oval</span>
                      </NuxtLink>
                  </div>
              </swiper-slide>
              <swiper-slide>
                  <div class="slide_box" :class="{ active: activeShape === 'pear' }" @click="$emit('shapeSelected', 'pear')">
                      <NuxtLink >
                          <picture>
                              <source width="40" height="40" type="image/webp" srcset="~/assets/shapes/pear.webp">
                              <img width="40" height="40" type="image/jpeg" src="~/assets/shapes/pear.jpg"
                                  alt="Pear Cut Diamonds">
                          </picture>
                          <span>pear</span>
                      </NuxtLink>
                  </div>
              </swiper-slide>
              <swiper-slide>
                  <div class="slide_box" :class="{ active: activeShape === 'cushion' }" @click="$emit('shapeSelected', 'cushion')">
                      <NuxtLink
                        >
                          <picture>
                              <source width="40" height="40" type="image/webp" srcset="~/assets/shapes/cushion.webp">
                              <img width="40" height="40" type="image/jpeg" src="~/assets/shapes/cushion.jpg"
                                  alt="Cushion Cut Diamonds">
                          </picture>
                          <span>cushion</span>
                      </NuxtLink>
                  </div>
              </swiper-slide>
              <swiper-slide>
                  <div class="slide_box" :class="{ active: activeShape === 'princess' }" @click="$emit('shapeSelected', 'princess')">
                      <NuxtLink
                          >
                          <picture>
                              <source width="40" height="40" type="image/webp" srcset="~/assets/shapes/princess.webp">
                              <img width="40" height="40" type="image/jpeg" src="~/assets/shapes/princess.jpg"
                                  alt="Princess Cut Diamonds">
                          </picture>
                          <span>princess</span>
                      </NuxtLink>
                  </div>
              </swiper-slide>
              <swiper-slide>
                  <div class="slide_box" :class="{ active: activeShape === 'radiant' }" @click="$emit('shapeSelected', 'radiant')">
                      <NuxtLink
                          >
                          <picture>
                              <source width="40" height="40" type="image/webp" srcset="~/assets/shapes/radiant.webp">
                              <img width="40" height="40" type="image/jpeg" src="~/assets/shapes/radiant.jpg"
                                  alt="Radiant Cut Diamonds">
                          </picture>
                          <span>radiant</span>
                      </NuxtLink>
                  </div>
              </swiper-slide>
              <swiper-slide>
                  <div class="slide_box" :class="{ active: activeShape === 'emerald' }" @click="$emit('shapeSelected', 'emerald')">
                      <NuxtLink
                          >
                          <picture>
                              <source width="40" height="40" type="image/webp" srcset="~/assets/shapes/emerald.webp">
                              <img width="40" height="40" type="image/jpeg" src="~/assets/shapes/emerald.jpg"
                                  alt="Emerald Cut Diamonds">
                          </picture>
                          <span>emerald</span>
                      </NuxtLink>
                  </div>
              </swiper-slide>
              <swiper-slide>
                  <div class="slide_box" :class="{ active: activeShape === 'heart' }" @click="$emit('shapeSelected', 'heart')">
                      <NuxtLink >
                          <picture>
                              <source width="40" height="40" type="image/webp" srcset="~/assets/shapes/heart.webp">
                              <img width="40" height="40" type="image/jpeg" src="~/assets/shapes/heart.jpg"
                                  alt="Heart Cut Diamonds">
                          </picture>
                          <span>heart</span>
                      </NuxtLink>
                  </div>
              </swiper-slide>
              <swiper-slide>
                  <div class="slide_box" :class="{ active: activeShape === 'asscher' }" @click="$emit('shapeSelected', 'asscher')">
                      <NuxtLink
                          >
                          <picture>
                              <source width="40" height="40"type="image/webp" srcset="~/assets/shapes/asscher.webp">
                              <img width="40" height="40" type="image/jpeg" src="~/assets/shapes/asscher.jpg"
                                  alt="Asscher Cut Diamonds">
                          </picture>
                          <span>asscher</span>
                      </NuxtLink>
                  </div>
              </swiper-slide>
              <swiper-slide>
                  <div class="slide_box" :class="{ active: activeShape === 'marquise' }" @click="$emit('shapeSelected', 'marquise')">
                      <NuxtLink
                          >
                          <picture>
                              <source width="40" height="40" type="image/webp" srcset="~/assets/shapes/marquise.webp">
                              <img width="40" height="40" type="image/jpeg" src="~/assets/shapes/marquise.jpg"
                                  alt="Marquise Cut Diamonds">
                          </picture>
                          <span>marquise</span>
                      </NuxtLink>
                  </div>
              </swiper-slide>
          </swiper>
            </div>
        </div>
    </div>
</template>

<script setup>
    const localePath = useLocalePath();
    const { $country } = useNuxtApp();
    const props = defineProps({
    activeShape: String,
    });
    const swiperOptions = {
      // loop:true,
      spaceBetween: 20,
      modules: [SwiperAutoplay],
      centerInsufficientSlides: true,
      breakpoints: {
          0: {
              slidesPerView: 3.7,
              slidesPerGroup: 1,
          },
          512: {
              slidesPerView: 4,
          },

          768: {
              slidesPerView: 5,
          },

         1400:{
             slidesPerView: 10,
         }
      },
  };

</script>

<style scoped>
.slide_box.active span {
  color: var(--green); 
}
.shape_flex {
    display: flex;
    align-items: flex-start;
    justify-content: space-around;
}
.slide_box{
    position: relative;
    cursor: pointer;
}
.shape_area {
    text-align: center;
}
.shape_upper p {
    color: #6a6161;
    font-size: 17px;
    text-align: center;
    width: 100;
    text-align: center;
}
.shape_upper a {
    display: block;
    color: #000;
    text-transform: uppercase;
    font-size: 14px;
    border: 1px solid #000;
    padding: 8px 14px;
    font-weight: 600;
    width: 100%;
    text-align: center;
}
.shape_upper {
    position: absolute;
    background: #f5f2f2;
    min-width: 360px;
    top: 100%;
    left: 50%;
    transform: translate(-50%, 25px);
    padding: 25px;
    z-index: 99;
    display: none;
}
.shape_upper:before {
    position: absolute;
    height: 30px;
    width: 30px;
    background: #f5f2f2;
    content: "";
    top: 0;
    left: 50%;
    transform: translate(-50%, -15px) rotate(45deg);
    z-index: -1;
}

button{
    background: #2a4437;
    color: #fff;
    border-color: #2a4437;
}
h4{
    font-size: 30px;
}
p{
    font-weight: 500;
    color: #6a6161;
}
p a{
    text-decoration: underline;
}
.shape_area {
    text-align: center;
}
 span {
    display: block;
    text-align: center;
    color: #000;
    text-transform: uppercase;
    font-size: 14px;
    margin-top: 15px;
    font-weight: 500;
    letter-spacing: 1.5px;
}

@media(max-width: 992px){
    .shape_upper{
        width: 280px;
    }
    .shape_upper p{
        font-size: 14px;
    }
    .shape_main {
        overflow-x: scroll;
        overflow-y: hidden;
    }
    .shape_flex {
        /* width: 1024px; */
    }
    p br{
        display: none;
    }
}
@media(max-width: 767px){
    .for_mobile{
        text-align: center;
    }

    .shape_flex {
        width: 1024px;
    }
    .test_block {
        
        margin: 7% 0;
    }
    span {
    font-size: 12px;
    letter-spacing: 1px;
}
    h4{
        font-size: 24px;
    }
    .shape_block {
        padding:0 2% 7%;
    }

}

</style>